import { AntiSpamFields } from "../../interfaces/main";
import { axiosInstance } from "./axiosConfig";

export default async function resendConfirmationMail(
  userEmail: string,
  antiSpamPayload?: AntiSpamFields
) {
  try {
    const res = await axiosInstance.post("/resend_confirmation_mail", {
      email: userEmail,
      ...antiSpamPayload,
    });
    return res;
  } catch (err) {
    throw err;
  }
}
